import { ForestSituation } from '../stand-creation-form/enums/forest-situation';
import { StandCreateWithDetailsDto } from 'orchestrator'
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export function getForestSituation(cycle: number, rotation: number): ForestSituation {
  if (cycle === 1 && rotation === 1) return ForestSituation.Plantable;
  if (cycle >= 1 && rotation >= 1) return ForestSituation.TUP;
  return ForestSituation.NotAvailable;
}

export function buildNgbDateToDateOnly(day: number, month: number, year: number) {
  const yyyy = String(year);
  const mm = String(month).padStart(2, '0');
  const dd = String(day).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function buildStandRequest(
  form: Record<string, unknown>,
  isPlanted: boolean,
  isMaintenanceTouched: boolean,
): StandCreateWithDetailsDto {

  const request: StandCreateWithDetailsDto = {
    standCreateBasicInfo:  {
      name: form['StandName'] as string,
      standArea: Number(form['StandArea']),
      gisArea: Number(form['GisArea'] ?? 0),
      propertyId: Number(form['PropertyId']),
      standTypeId: Number(form['StandTypeId']),
      hasNearbyPopulation: JSON.parse(form['HasNearbyPopulation'] as string),
    }
  };

  if (form['CurrentCycle'] && form['CurrentRotation']) {
    request.standCreateCycleRotation = {
      cycle: Number(form['CurrentCycle']),
      rotation: Number(form['CurrentRotation']),
    };
  }

  if (isMaintenanceTouched) {
    request.standCreateAreaMaintenance = {
      adjustmentReasonId: Number(form['Reason']),
      isAreaUpdated:  Boolean(form['IsAreaUpdated']),
      periodId:Number(form['Period']),
      standAreaMaintenanceTypeId: Number(form['AdjustmentType']),
      notes: form['Notes'] as string,
    };
  }

  if (isPlanted) {
    const dateObject = form['PlantingDate'] as NgbDate
    const plantationDate = buildNgbDateToDateOnly(dateObject.day, dateObject.month, dateObject.year);

    request.standCreatePlantation = {
      geneticMaterialId: Number(form['GeneticMaterial']),
      plantationDate,
      plantationTypeId: Number(form['PlantingType']),
      spacingId: Number(form['Spacing']),
      isOwnPlantation: Boolean(form['ownPlantation']),
    };
  }
  return request;
}
